import {
  defaultCellRenderer,
  defaultCellRenderer as renderer,
  defaultGroupRenderer as groupRenderer,
  linkifyText
} from "../../utils/utils.jsx";
import { WIDGET_KEYS } from "../WidgetKeys.jsx";
import { customGroupByOrder } from "../../utils/otherUtils.jsx";

export const RESOURCE_VIEW_COLUMNS = [
  {
    id: "resource-icon",
    type: WIDGET_KEYS.columnResourceTagIcon,
    field: "iconValue",
    region: "left",
    flex: 1,
    align: "center",
    editor: false,
  },
  {
    id: "resources-icon-label",
    type: WIDGET_KEYS.columnEntityMainName,
    text: "Resource ID",
    region: "left",
    field: "name",
    align: 'left',
    flex: 1,
    groupRenderer,
    headerMenuItems: {
      addNewEntity: {
        _menuId: "resource",
        icon: "fa-plus",
        text: "New Resource",
        weight: 10
      }
    }
  },
  {
    id: "plan-resource-contacts",
    type: WIDGET_KEYS.contactColumn
  },
  {
    id: "plan-resource-reminder-bell",
    type: WIDGET_KEYS.alertBellColumn,
    isAlertBell: true,
  },
  {
    id: "plan-resource-notes",
    type: WIDGET_KEYS.notesColumn,
  },
  {
    id: "plan-resource-media",
    type: WIDGET_KEYS.mediaColumn,
  },
  {
    id: "plan-resource-documents",
    type: WIDGET_KEYS.documentsColumn,
  },
  {
    id: "resource-blackout-icon-1",
    type: WIDGET_KEYS.columnResourceBlackout,
    hidden: true,
  },
  {
    id: "resource-description",
    text: "Description",
    field: "description",
    flex: 1,
    cellCls: "!overflow-hidden",
    renderer: ({ record }) => linkifyText(defaultCellRenderer({ value: record.description })),
    groupRenderer
  },
  {
    id: "resource-assigned-to",
    editor: false,
    type: WIDGET_KEYS.assignToColumn,
    swivuListTitle: "Resource Assigned To",
    onSwivuEditMessage: "onClickSwivuUserEditMessage",
  },
  {
    id: "resource-eligible-users-v1",
    editor: false,
    swivuListTitle: "Resource Points Eligible",
    type: WIDGET_KEYS.eligibleUserColumn,
    onSwivuEditMessage: "onClickSwivuUserEditMessage",
    hidden: true
  },
  { id: "resource-checklist", type: WIDGET_KEYS.checklistColumn },
  {
    id: "resource-team",
    text: "Team",
    field: "teamValue",
    editor: false,
    type: WIDGET_KEYS.teamField,
    flex: 1,
    swivuListTitle: "Resource Team",
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  {
    id: "resource-job",
    text: "Sub Type",
    field: "jobTitle",
    flex: 1,
    renderer,
    groupRenderer
  },
  {
    id: "resource-aging",
    text: "Age",
    field: "aging",
    flex: 1,
    type: "agingColumn",
    editor: false
  },
  {
    id: "resource-status",
    text: "Status",
    flex: 1,
    field: "statusValue",
    editor: false,
    type: WIDGET_KEYS.columnResourceStatus,
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    }
  },
  {
    id: "resource-category",
    text: "Category",
    flex: 1,
    field: "categoryValue",
    editor: false,
    type: WIDGET_KEYS.columnResourceCategory,
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    }
  },
  {
    id: "resource-tag",
    text: "Tags",
    editor: false,
    type: WIDGET_KEYS.columnResourceTag,
    flex: 1,
    field: "tagsValue",
  },
  {
    id: "resource-type",
    editor: false,
    swivuListTitle: "Resource Type",
    type: WIDGET_KEYS.columnResourceType,
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  { id: "resource-location", text: "Location", field: "location", flex: 1, renderer,
    groupRenderer
  },
  {
    id: "resource-time-axis-column",
    type: 'timeAxis',
  }
];
